
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/handyman",
      function () {
        return require("private-next-pages/services/handyman/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/handyman"])
      });
    }
  